(function () {

  'use strict';

  //*****************//
  // Data that this directive needs
  // -----------------
  // Requires a paginationObject, that is reInited whenever the popup is called
  //*****************//

  // 
  // }

  function pxPagination(NetworkListService, GroupListService, PrinterListService, PrinterVendorService) {
    return {
      restrict: 'EA',
      scope: {
        paginationData: '=paginationData',
        callback: '&callback',
      },
      templateUrl: 'app/directives/pagination/pagination.template.html',
      link: function (scope) {



        scope.paginationData.paginationObject.pagingCriteria.page = 0;
        scope.paginationData.paginationObject.pagingCriteria.match = null;
        scope.paginationObject = scope.paginationData.paginationObject;
        scope.searchInputPlaceholderText = scope.paginationData.placeholderText;
        scope.selectedItem = null;
        scope.selectedItems = [];
        scope.toggleAttachmentState  = false;
        scope.selectedAttachmentItem = null;
        scope.context = scope.paginationData.context ? scope.paginationData.context : null;

        function setClasses() {
          angular.element('.nested-pagination').css({height: scope.paginationData.contentHeight - 227});
          scope.getListPaged();
        }

        scope.getListPaged = function () {
          if (scope.paginationData.service === 'NetworkListService') {
            NetworkListService.getNetworkListPaged(scope.paginationObject).then(function (pageContent) {
              scope.pageContent = pageContent;
              scope.pagedContainer = pageContent.list;
            }).catch(function(error){});
          }
          
          if (scope.paginationData.service === 'GroupListService') {
            GroupListService.getGroupListPaged(scope.paginationObject).then(function (pageContent) {
              scope.pageContent = pageContent;
              scope.pagedContainer = pageContent.list;
              checkForSelectedItems();
            }).catch(function(error){});
          }
          
          if (scope.paginationData.service === 'PrinterVendorService') {
            PrinterVendorService.getPrinterVendorsListPaged(scope.paginationObject).then(function (pageContent) {
              scope.pageContent = pageContent;
              scope.pagedContainer = pageContent.list;
            }).catch(function(error){});
          }
        }

        function checkForSelectedItems () {
          angular.forEach(scope.pagedContainer, function(pagedItem) { 
            pagedItem.options.isSelected = false;
          })

          angular.forEach(scope.pagedContainer, function(pagedItem) {
            angular.forEach(scope.selectedItems, function(selectedItem) {
              if (pagedItem.info._links.self.href === selectedItem.info._links.self.href) {
                pagedItem.options.isSelected = true;
              } 
            })
          })
        }

        scope.getNextPage = function functionName(showPrevious) {
          if (showPrevious) {
            if (scope.paginationObject.pagingCriteria.page > 0) {
              scope.paginationObject.pagingCriteria.page--;
            }
          } else {
            if (scope.paginationObject.pagingCriteria.page + 1 < scope.pageContent.page.totalPages) {
              scope.paginationObject.pagingCriteria.page++;
            }
          }
          scope.getListPaged();
        }

        scope.removeSelectedItem = function ($event, removeItem) {
          $event.preventDefault();
          angular.forEach(scope.selectedItems, function(selectedItem) {
            if (selectedItem.info._links.self.href === removeItem.info._links.self.href) {
              scope.selectedItems.remove(removeItem);
            }
          })

          if (scope.selectedItem && scope.selectedItem.options.isSelected) {
            scope.callback({item: scope.selectedItem, boolean: true, selectedAttachmentItem: scope.selectedAttachmentItem, context: scope.context})
          } else {
            scope.callback({item: null, boolean: false, selectedAttachmentItem: scope.selectedAttachmentItem, context: scope.context})
          }

          checkForSelectedItems();
        }

        scope.changeItem = function (selectedItem) {
          if (scope.paginationData.multiSelect) {
            multiSelect(selectedItem);
          } else {
            scope.selectedItem = selectedItem;
            singleSelect(selectedItem);
          }
        }

        scope.toggleAttachment = function() {
          scope.toggleAttachmentState = !scope.toggleAttachmentState;
        }

        scope.selectAttachmentItem = function (item) {
          scope.selectedAttachmentItem = item;
          if (scope.paginationData.multiSelect) {
            multiSelect();
          } else {
            if (scope.selectedItem && scope.selectedItem.options.isSelected) {
              scope.callback({item: scope.selectedItem, boolean: true, selectedAttachmentItem: scope.selectedAttachmentItem, context: scope.context})
            } else {
              scope.callback({item: null, boolean: false, selectedAttachmentItem: scope.selectedAttachmentItem, context: scope.context})
            }
          }
        }
        
        function multiSelect(selectedItem) {
          if (selectedItem) {
            selectedItem.options.isSelected = !selectedItem.options.isSelected;
            
            if (selectedItem.options.isSelected) {
              scope.selectedItems.add(selectedItem) 
            } else {
              scope.selectedItems.remove(selectedItem);
            }
          }

          if (scope.selectedItems.length > 0) {
            scope.callback({item: scope.selectedItems, boolean: true, selectedAttachmentItem: scope.selectedAttachmentItem, context: scope.context});
          } else {
            scope.callback({item: null, boolean: false, selectedAttachmentItem: scope.selectedAttachmentItem, context: scope.context});
          }
        }

        function singleSelect (selectedItem) {
          angular.forEach(scope.pagedContainer, function(item){
            if (selectedItem.info._links.self.href !== item.info._links.self.href) {
              item.options.isSelected = false;
            }
          })
          selectedItem.options.isSelected = !selectedItem.options.isSelected;
            
          if (selectedItem.options.isSelected) {
            scope.callback({item: selectedItem, boolean: true, selectedAttachmentItem: scope.selectedAttachmentItem, context: scope.context})
          } else {
            scope.callback({item: null, boolean: false, selectedAttachmentItem: scope.selectedAttachmentItem, context: scope.context})
          }
        }

        function checkAttachment () {
          if (scope.paginationData.attachment) {
            switch (scope.paginationData.attachment.type) {
              case 'SELECT': 
                scope.selectedAttachmentItem = setDefaultAttachment();
              break;
            }
          }
        }

        function setDefaultAttachment () {
          for (var i = 0; i < scope.paginationData.attachment.select.listRaw.length; i++) {
            if (scope.paginationData.attachment.select.listRaw[i].info.tenantDefault) {
              return scope.paginationData.attachment.select.listRaw[i];
            }
          }

          return scope.paginationData.attachment.select.listRaw[0];
        }


        function init() {
          setClasses()
          checkAttachment()
        }

        init();

      }
    };
  }

  pxPagination.$inject = ['NetworkListService', 'GroupListService', 'PrinterListService', 'PrinterVendorService'];

  angular
    .module('printix-admin')
    .directive('pxPagination', pxPagination);

})();